import { createContext, useState, useContext } from "react";

// Створення контексту
const LanguageContext = createContext();

// Хук для зручного використання контексту
export const useLanguage = () => useContext(LanguageContext);

// LanguageProvider — обгортка для управління мовою
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en"); // Поточна мова (за замовчуванням — англійська)

  // Функція для зміни мови
  const switchLanguage = lang => setLanguage(lang);

  return (
    <LanguageContext.Provider value={{ language, switchLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
